import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  BrowserRouter,
} from "react-router-dom";
import Dashboard from "./Components/Dashboard/Dashboard";
import Withdrawal_Payment_Reports from "./Components/Withdrawal/Withdrawal_Payment_Reports";
import Withdrawal_Pending_List from "./Components/Withdrawal/Withdrawal_Pending_List";
import Login from "./Components/Login/Login";
import OPT_Confirm from "./Components/Login/OPT_Confirm";
import WithdrawlStart_Stop from "./Components/Member/WithdrawlStart_Stop";
import Message from "./Components/Dashboard Message/Message";
import MessageHistory from "./Components/Dashboard Message/MessageHistory";
import ProtectedRoute from "./Redux/actions/ProtectedRoute";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Buy from "./Components/Trading/Buy";
import Sell from "./Components/Trading/Sell";
import TrandingWithdrawHistory from "./Components/Member/TrandingWithdrawHistory";
import Staking_Claim_History from "./Components/Member/Staking_Claim_History";
import Edit_details from "./Components/Member/Edit_details";
import HelpDesk from "./Components/HelpDesk/HelpDesk";
import News from "./Components/HelpDesk/News";
import Reply from "./Components/HelpDesk/Reply";
import Commission from "./Components/HelpDesk/Commission";
import LoginHistory from "./Components/HelpDesk/LoginHistory";
// import ApprovedKyc  from "./Components/Kyc/ApprovedKyc";
// import PendingKyc from "./Components/Kyc/PendingKyc";
import Manage_subadmin from "./Components/Sub_Admin/Manage_subadmin";
import Subadmin_rights from "./Components/Sub_Admin/Subadmin_rights";
import Edit_subAdmin from "./Components/Sub_Admin/Edit_subAdmin";
import Add_subAdmin from "./Components/Sub_Admin/Add_subAdmin";
import My_Team from "./Components/Team_Reports/My team";
import Contact from "./Components/Contact/Contact";
import Add_HomePageCoin from "./Components/HomePageCoin/Add_HomePageCoin";
import HomePageCoinDetails from "./Components/HomePageCoin/HomePageCoinDetails";
import Update_HomePageCoin from "./Components/HomePageCoin/Update_HomePageCoin";
import RequestToken from "./Components/Request Token/RequestToken";
import RequestTokenUpdate from "./Components/Request Token/RequestTokenUpdate";
import RequestTokenPaid from "./Components/Request Token/RequestTokenPaid";
import RequestTokenCancel from "./Components/Request Token/RequestTokenCancel";
import Active_Member from "./Components/Member/ACTIVE_MEMBER_LIST";
import Level_detail from "./Components/Team_Reports/Level_detail";
import Direct_team from "./Components/Team_Reports/Direct_team";
import ActivationByAdmin from "./Components/Activation/ActivationByAdmin";
import RetopupHistory from "./Components/Member/RetopupHistory";
import All_member from "./Components/Member/All_member";
import ActivationUHistory from "./Components/Activation/ActivationUHistory";
import DirectLegBusiness from "./Components/Team_Reports/DirectLegBusiness";
import AddPowerleg from "./Components/Power Leg/AddPowerleg";
import PowerlegHis from "./Components/Power Leg/PowerlegHis";
import RoiRate from "./Components/Power Leg/RoiRate";
import LevelIncome from "./Components/Income Reports/LevelIncome";
import RoyaltyIncome from "./Components/Income Reports/RoyaltyIncome";
import Total_incomeReport from "./Components/Income Reports/Total_incomeReport";
import RoiIncome from "./Components/Income Reports/RoiIncome";
import ClosedHelpDesk from "./Components/HelpDesk/ClosedHelpDesk";
import SubadminHistory from "./Components/Sub_Admin/SubadminHistory";
import InvestmentSummary from "./Components/Member/InvestmentSummary";
import Member_Details from "./Components/Member/Member_Details";
import DirectIncome from "./Components/Income Reports/DirectIncome";
import Upgrade_MEMBER_LIST from "./Components/Member/Upgrade_MEMBER_LIST";
import TeamRewardPaid from "./Components/Income Reports/TeamRewardPaid";
import Withdrawal_Pending_List_nonworking from "./Components/Withdrawal/PendingClaimActvationHistory";
import Withdrawal_Payment_Reports_nonworking from "./Components/Withdrawal/PaidClaimActvationHistory";
import PendingClaimActvationHistory from "./Components/Withdrawal/PendingClaimActvationHistory";
import PaidClaimActvationHistory from "./Components/Withdrawal/PaidClaimActvationHistory";
import QualifyLevelMember from "./Components/Member/QualifyLevelMember";
import UpgradeByAdmin from "./Components/Activation/UpgradeByAdmin";
import ActivationUserHistory from "./Components/Activation/ActivationUserHistory";
import BinaryIncome from "./Components/Income Reports/BinaryIncome";
import GrossBinaryIncome from "./Components/Income Reports/GrossBinaryIncome";
import RewardAchiever from "./Components/Income Reports/RewardAchiever";
import Withdrawal_Roi_Pending_List from "./Components/Withdrawal/Withdrawal_Roi_Pending_List";
import ActivationFund from "./Components/Add Fund/ActivationFund";
import AfundHistory from "./Components/Add Fund/AfundHistory";
import IncomeToFundConvert from "./Components/Add Fund/IncomeToFundConvert";
import UsertoUserTranssfer from "./Components/Add Fund/UsertoUserTranssfer";
import PoolIncome from "./Components/Income Reports/PoolIncome";
import My_team_Booster from "./Components/Team_Reports/My_team_Booster";
import My_Team_autoPool from "./Components/Team_Reports/My_Team_autoPool";
import ActivationByAdminBooster from "./Components/Activation/ActivationByAdminBooster";
import BoosterActivationUHistory from "./Components/Activation/BoosterActivationUHistory";
import My_Team_autoPoolDetails from "./Components/Team_Reports/My_Team_autoPoolDetails";
import My_team_BoosterDetails from "./Components/Team_Reports/My_team_BoosterDetails";
import ClubIncomebooster from "./Components/Income Reports/ClubIncomebooster";
import ClubIncome from "./Components/Income Reports/ClubIncome";
import UplinewWithdrawalIncome from "./Components/Income Reports/UplinewWithdrawalIncome";
import User_airdrop from "./Components/Income Reports/User_airdrop";
import LevelIncomeAirdrop from "./Components/Income Reports/LevelIncomeAirdrop";
import ClubAchiever from "./Components/Income Reports/ClubAchiever";
import UpdateTurnOver from "./Components/Income Reports/UpdateTurnOver";

function App() {
  // useEffect(() => {
  //   const handleContextMenu = (event) => {
  //     event.preventDefault();
  //   };

  //   document.addEventListener("contextmenu", handleContextMenu);

  //   document.addEventListener("keydown", (e) => {
  //     if (
  //       (e.ctrlKey &&
  //         (e.key === "I" ||
  //           e.key === "i" ||
  //           e.key === "u" ||
  //           e.key === "U" ||
  //           e.key === "J" ||
  //           e.key === "j" ||
  //           e.key === "C" ||
  //           e.key === "c")) ||
  //       e.key === "F12"
  //     ) {
  //       e.preventDefault();
  //     }
  //   });

  //   return () => {
  //     document.removeEventListener("contextmenu", handleContextMenu);
  //   };
  // }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ToastContainer />
        <Routes>
          <Route />
          <Route exact path="/" element={<Login />} />
          <Route exact path="/OPT_Confirm" element={<OPT_Confirm />} />
          <Route
            exact
            path="/Dashboard"
            element={<ProtectedRoute component={Dashboard} />}
          />
          <Route
            exact
            path="/Allmember"
            element={<ProtectedRoute component={All_member} />}
          />
          <Route
            exact
            path="/Dashboard_Message"
            element={<ProtectedRoute component={Message} />}
          />
          <Route
            exact
            path="/MessageHistory"
            element={<ProtectedRoute component={MessageHistory} />}
          />
          <Route
            exact
            path="/Member_Details"
            element={<ProtectedRoute component={Member_Details} />}
          />
          <Route
            exact
            path="/WithdrawlStart_Stop"
            element={<ProtectedRoute component={WithdrawlStart_Stop} />}
          />
          <Route
            exact
            path="/ActiveMember"
            element={<ProtectedRoute component={Active_Member} />}
          />
          <Route
            exact
            path="/upgradeMember"
            element={<ProtectedRoute component={Upgrade_MEMBER_LIST} />}
          />
          <Route
            exact
            path="/QualifyLevelMember"
            element={<ProtectedRoute component={QualifyLevelMember} />}
          />
          <Route
            exact
            path="/BusinessSummary"
            element={<ProtectedRoute component={InvestmentSummary} />}
          />
          <Route
            exact
            path="/RetopupHistory"
            element={<ProtectedRoute component={RetopupHistory} />}
          />
          <Route
            exact
            path="/Activation"
            element={<ProtectedRoute component={ActivationByAdmin} />}
          />
          <Route
            exact
            path="/Upgrade"
            element={<ProtectedRoute component={UpgradeByAdmin} />}
          />
          <Route
            exact
            path="/Activationhistory"
            element={<ProtectedRoute component={ActivationUHistory} />}
          />
          <Route
            exact
            path="/ActivationUserHistory"
            element={<ProtectedRoute component={ActivationUserHistory} />}
          />
          <Route
            exact
            path="/roirate"
            element={<ProtectedRoute component={RoiRate} />}
          />
          <Route
            exact
            path="/addpower"
            element={<ProtectedRoute component={AddPowerleg} />}
          />
          <Route
            exact
            path="/powerhistory"
            element={<ProtectedRoute component={PowerlegHis} />}
          />
          <Route
            exact
            path="/Withdrawal_History"
            element={<ProtectedRoute component={Withdrawal_Payment_Reports} />}
          />
          <Route
            exact
            path="/PaidClaimActvationHistory"
            element={<ProtectedRoute component={PaidClaimActvationHistory} />}
          />
          <Route
            exact
            path="/Pending_Withdrawal"
            element={<ProtectedRoute component={Withdrawal_Pending_List} />}
          />
          <Route
            exact
            path="/Pending_Roi_Withdrawal"
            element={<ProtectedRoute component={Withdrawal_Roi_Pending_List} />}
          />
          <Route
            exact
            path="/PendingClaimActvationHistory"
            element={
              <ProtectedRoute component={PendingClaimActvationHistory} />
            }
          />
          <Route
            exact
            path="/Buy"
            element={<ProtectedRoute component={Buy} />}
          />
          <Route
            exact
            path="/Sell"
            element={<ProtectedRoute component={Sell} />}
          />
          <Route
            exact
            path="/DepositeHistory"
            element={<ProtectedRoute component={Staking_Claim_History} />}
          />
          <Route
            exact
            path="/Cancel_Withdrawal"
            element={<ProtectedRoute component={TrandingWithdrawHistory} />}
          />
          <Route
            exact
            path="/Edit_Details"
            element={<ProtectedRoute component={Edit_details} />}
          />
          <Route
            exact
            path="/HelpDesk"
            element={<ProtectedRoute component={HelpDesk} />}
          />
          <Route
            exact
            path="/ClosedHelpDesk"
            element={<ProtectedRoute component={ClosedHelpDesk} />}
          />
          <Route
            exact
            path="/Reply"
            element={<ProtectedRoute component={Reply} />}
          />
          <Route
            exact
            path="/News"
            element={<ProtectedRoute component={News} />}
          />
          <Route
            exact
            path="/PendingReward"
            element={<ProtectedRoute component={RequestToken} />}
          />
          <Route
            exact
            path="/PaidRewardHistory"
            element={<ProtectedRoute component={RequestTokenPaid} />}
          />
          <Route
            exact
            path="/RequestTokenUpdate"
            element={<ProtectedRoute component={RequestTokenUpdate} />}
          />
          <Route
            exact
            path="/Commission_Report"
            element={<ProtectedRoute component={Commission} />}
          />
          <Route
            exact
            path="/LoginHistory"
            element={<ProtectedRoute component={LoginHistory} />}
          />
          {/* <Route exact path="/ApprovedKyc" element={<ProtectedRoute component={ApprovedKyc}/>} />
        <Route exact path="/PendingKyc" element={<ProtectedRoute component={PendingKyc}/>} /> */}
          <Route
            exact
            path="/Manage_subadmin"
            element={<ProtectedRoute component={Manage_subadmin} />}
          />
          <Route
            exact
            path="/Subadmin_rights"
            element={<ProtectedRoute component={Subadmin_rights} />}
          />
          <Route
            exact
            path="/Edit_SubAdmin"
            element={<ProtectedRoute component={Edit_subAdmin} />}
          />
          <Route
            exact
            path="/Add_SubAdmin"
            element={<ProtectedRoute component={Add_subAdmin} />}
          />
          <Route
            exact
            path="/BinaryIncome"
            element={<ProtectedRoute component={BinaryIncome} />}
          />
          <Route
            exact
            path="/GrossBinaryIncome"
            element={<ProtectedRoute component={GrossBinaryIncome} />}
          />
          <Route
            exact
            path="/LevelIncome"
            element={<ProtectedRoute component={LevelIncome} />}
          />
          <Route
            exact
            path="/RoiIncome"
            element={<ProtectedRoute component={RoiIncome} />}
          />
          <Route
            exact
            path="/RewardAchiever"
            element={<ProtectedRoute component={RewardAchiever} />}
          />
          <Route
            exact
            path="/RoyaltyIncome"
            element={<ProtectedRoute component={RoyaltyIncome} />}
          />
          <Route
            exact
            path="/TeamRewardPaid"
            element={<ProtectedRoute component={TeamRewardPaid} />}
          />
          <Route
            exact
            path="/DirectIncome"
            element={<ProtectedRoute component={DirectIncome} />}
          />
          <Route
            exact
            path="/Total_incomeReport"
            element={<ProtectedRoute component={Total_incomeReport} />}
          />
          {/* <Route exact path="/Add_MarketCoin" element={<ProtectedRoute component={Add_MarketCoin}/>} /> 
        <Route exact path="/MarketCoinHistory" element={<ProtectedRoute component={MarketCoinHistory}/>} /> 
        <Route exact path="/Update_Coin_Details" element={<ProtectedRoute component={UpdateCoin}/>}/> */}
          <Route
            exact
            path="/My_Team"
            element={<ProtectedRoute component={My_Team} />}
          />
          <Route
            exact
            path="/myreferrals"
            element={<ProtectedRoute component={Direct_team} />}
          />
          <Route
            exact
            path="/Level_detail"
            element={<ProtectedRoute component={Level_detail} />}
          />
          <Route
            exact
            path="/DirectLegBusiness"
            element={<ProtectedRoute component={DirectLegBusiness} />}
          />
          <Route
            exact
            path="/levelDetails"
            element={<ProtectedRoute component={Level_detail} />}
          />
          <Route
            exact
            path="/Contact_Query"
            element={<ProtectedRoute component={Contact} />}
          />
          <Route
            exact
            path="/Add_HomePageCoin"
            element={<ProtectedRoute component={Add_HomePageCoin} />}
          />
          <Route
            exact
            path="/HomePageCoinDetails"
            element={<ProtectedRoute component={HomePageCoinDetails} />}
          />
          <Route
            exact
            path="/Update_HomePageCoin"
            element={<ProtectedRoute component={Update_HomePageCoin} />}
          />
          <Route
            exact
            path="/RequestTokenCancel"
            element={<ProtectedRoute component={RequestTokenCancel} />}
          />
          <Route
            exact
            path="/SubadminHistory"
            element={<ProtectedRoute component={SubadminHistory} />}
          />
          <Route
            exact
            path="/activationfund"
            element={<ProtectedRoute component={ActivationFund} />}
          />
          <Route
            exact
            path="/activationfundHis"
            element={<ProtectedRoute component={AfundHistory} />}
          />
          <Route
            exact
            path="/IncomeToFundConvert"
            element={<ProtectedRoute component={IncomeToFundConvert} />}
          />
          <Route
            exact
            path="/UsertoUserTranssfer"
            element={<ProtectedRoute component={UsertoUserTranssfer} />}
          />
          <Route
            exact
            path="/PoolIncome"
            element={<ProtectedRoute component={PoolIncome} />}
          />
          <Route
            exact
            path="/My_team_Booster"
            element={<ProtectedRoute component={My_team_Booster} />}
          />
          <Route
            exact
            path="/My_Team_autoPool"
            element={<ProtectedRoute component={My_Team_autoPool} />}
          />
          <Route
            exact
            path="/ActivationByAdminBooster"
            element={<ProtectedRoute component={ActivationByAdminBooster} />}
          />
          <Route
            exact
            path="/BoosterActivationhistory"
            element={<ProtectedRoute component={BoosterActivationUHistory} />}
          />
          <Route
            exact
            path="/My_Team_autoPoolDetails"
            element={<ProtectedRoute component={My_Team_autoPoolDetails} />}
          />
          <Route
            exact
            path="/My_team_BoosterDetails"
            element={<ProtectedRoute component={My_team_BoosterDetails} />}
          />
          <Route
            exact
            path="/ClubIncomebooster"
            element={<ProtectedRoute component={ClubIncomebooster} />}
          />
          <Route
            exact
            path="/ClubIncome"
            element={<ProtectedRoute component={ClubIncome} />}
          />
          <Route
            exact
            path="/UplinewWithdrawalIncome"
            element={<ProtectedRoute component={UplinewWithdrawalIncome} />}
          />
          <Route
            exact
            path="/User_airdrop"
            element={<ProtectedRoute component={User_airdrop} />}
          />
          <Route
            exact
            path="/LevelIncomeAirdrop"
            element={<ProtectedRoute component={LevelIncomeAirdrop} />}
          />
          <Route
            exact
            path="/ClubAchiever"
            element={<ProtectedRoute component={ClubAchiever} />}
          />{" "}
          <Route
            exact
            path="/UpdateTurnOver"
            element={<ProtectedRoute component={UpdateTurnOver} />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
